import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import MatrixNineBoxesServices from "./matrixNineBoxes.services";

toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
};

export const getMatrixNineBoxes = filters => async (dispatch) => {
    try {
        dispatch({
            type: actions.LOADER_MATRIX_NINE_BOXES,
            payload: true,
        });
        const resp = await MatrixNineBoxesServices.getMatrixNineBoxes(filters);
        const respAnio = await MatrixNineBoxesServices.getMatrixNineBoxes({});
        let temp = {data:[]};
        respAnio&&respAnio.data.data.map((item)=>{
            if(item.anio && !temp.data.find(t=>t.anio===item.anio)){
              temp.data.push(item)
            }
        })
        //console.log("data del action get", resp.data)
        dispatch({
            type: actions.GET_MATRIX_NINE_BOXES,
            payload: {matrixNineBoxes: resp.data, matrixNineBoxesAnio: temp},
        });
        dispatch({
            type: actions.MATRIX_NINE_BOXES_FAIL,
            payload: null,
        });
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    case 403:
                        if (ex.response.data && ex.response.data.detail) {
                            message = ex.response.data.detail;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError
        }
        dispatch({
            type: actions.MATRIX_NINE_BOXES_FAIL,
            payload: message
        })
    } finally {
        dispatch({
            type: actions.LOADER_MATRIX_NINE_BOXES,
            payload: false,
        });
    }
}

export const saveMatrixNineBoxes = (req, setShowModal) => async (dispatch, getState) => {
    try {
        dispatch({
            type: actions.SAVE_LOADER_MATRIX_NINE_BOXES,
            payload: true,
        });
        const resp = await MatrixNineBoxesServices.saveMatrixNineBoxes(req);
        const { data, count } = getState().matrixNineBoxes.matrixNineBoxes;
        const { data: dataAnio } = getState().matrixNineBoxes.matrixNineBoxesAnio;
        let _dataAnio = dataAnio
        if(!_dataAnio.find(t=>t.anio===resp.data.anio)){
            _dataAnio.push(resp.data)
          }
        dispatch({
            type: actions.GET_MATRIX_NINE_BOXES,
            payload: {matrixNineBoxes: {data: [...data, resp.data],count: count + 1}, matrixNineBoxesAnio: {data: _dataAnio}},
        });
        dispatch({
            type: actions.FORM_MATRIX_NINE_BOXES_FAIL,
            payload: "",
        });
        setShowModal(false)
        toastr.success(messages.successMessage, "", {
            progressBar: true,
            rtl: true,
        });
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    case 500:
                        message = messages.errorMessage + " " + ex.response.statusText;
                        break;
                    case 403:
                        if (ex.response.data && ex.response.data.detail) {
                            message = ex.response.data.detail;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = ex.response.data;
                        break;
                }
            } else {
                message =
                    ex.message === "Network Error" ? messages.networkError : ex.message;
            }
        } else {
            message =
                ex.message === "Network Error" ? messages.networkError : ex.message;
        }
        dispatch({
            type: actions.FORM_MATRIX_NINE_BOXES_FAIL,
            payload: message,
        });
    } finally {
        dispatch({
            type: actions.SAVE_LOADER_MATRIX_NINE_BOXES,
            payload: false,
        });
    }
};

export const saveOrderingboxes = (req) => async (dispatch, getState) => {
    try {
        dispatch({
            type: actions.SAVE_LOADER_MATRIX_NINE_BOXES,
            payload: true,
        });
        const resp = await MatrixNineBoxesServices.saveOrderingboxes(req);
        const { data, count } = getState().matrixNineBoxes.matrixNineBoxes;
        const { data: dataAnio } = getState().matrixNineBoxes.matrixNineBoxesAnio;
        dispatch({
            type: actions.GET_MATRIX_NINE_BOXES,
            payload: {matrixNineBoxes: {data: resp.data.resultado, count: count}, matrixNineBoxesAnio: {data: dataAnio}},
        });
        // dispatch({
        //     type: actions.GET_MATRIX_NINE_BOXES,
        //     payload: {
        //         data: resp.data.resultado,
        //         count: count,
        //     },
        // });
        dispatch({
            type: actions.FORM_MATRIX_NINE_BOXES_FAIL,
            payload: "",
        });
        toastr.success(messages.successMessage, "", {
            progressBar: true,
            rtl: true,
        });
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    case 500:
                        message = messages.errorMessage + " " + ex.response.statusText;
                        break;
                    case 403:
                        if (ex.response.data && ex.response.data.detail) {
                            message = ex.response.data.detail;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = ex.response.data;
                        break;
                }
            } else {
                message =
                    ex.message === "Network Error" ? messages.networkError : ex.message;
            }
        } else {
            message =
                ex.message === "Network Error" ? messages.networkError : ex.message;
        }
    } finally {
        dispatch({
            type: actions.SAVE_LOADER_MATRIX_NINE_BOXES,
            payload: false,
        });
    }
};

export const editMatrixNineBoxes = (req, index, setShowModal) => async (dispatch, getState) => {
    try {
        dispatch({
            type: actions.LOADER_MATRIX_NINE_BOXES,
            payload: true,
        });
        const resp = await MatrixNineBoxesServices.editMatrixNineBoxes(req.id, req);
        const { data, count } = getState().matrixNineBoxes.matrixNineBoxes;
        const { data: dataAnio } = getState().matrixNineBoxes.matrixNineBoxesAnio;
        let _data = data.slice();
        _data[index] = resp.data;
        dispatch({
            type: actions.GET_MATRIX_NINE_BOXES,
            payload: {matrixNineBoxes: {data: _data, count: count}, matrixNineBoxesAnio: {data: dataAnio}},
        });
        // dispatch({
        //     type: actions.GET_MATRIX_NINE_BOXES,
        //     payload: {
        //         data: _data,
        //         count: count,
        //     },
        // });
        dispatch({
            type: actions.FORM_MATRIX_NINE_BOXES_FAIL,
            payload: "",
        });
        setShowModal(false)
        toastr.success(messages.successMessage, "", {
            progressBar: true,
            rtl: true,
        });

    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError
        }
        dispatch({
            type: actions.FORM_MATRIX_NINE_BOXES_FAIL,
            payload: message
        })
    } finally {
        dispatch({
            type: actions.LOADER_MATRIX_NINE_BOXES,
            payload: false,
        });
    }
}

export const deleteMatrixNineBoxes = (id, index, reOrder, list) => async (dispatch, getState) => {
    try {
        dispatch({
            type: actions.LOADER_MATRIX_NINE_BOXES,
            payload: true,
        });
        await MatrixNineBoxesServices.deleteMatrixNineBoxes(id);
        const { data, count } = getState().matrixNineBoxes.matrixNineBoxes;
        const { data: dataAnio } = getState().matrixNineBoxes.matrixNineBoxesAnio;
        let _data = data.slice();
        let _list = list.slice();
        _list.splice(index, 1);
        _data.splice(index, 1);
        dispatch({
            type: actions.GET_MATRIX_NINE_BOXES,
            payload: {matrixNineBoxes: {data: _list, count: count - 1}, matrixNineBoxesAnio: {data: dataAnio}},
        });
        // dispatch({
        //     type: actions.GET_MATRIX_NINE_BOXES,
        //     payload: {
        //         data: _list,
        //         count: count - 1
        //     },
        // });
        reOrder(_list);
        dispatch({
            type: actions.MATRIX_NINE_BOXES_FAIL,
            payload: '',
        });
        toastr.success(messages.successMessage, "", {
            progressBar: true,
            rtl: true,
        });
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError
        }
        dispatch({
            type: actions.MATRIX_NINE_BOXES_FAIL,
            payload: message
        })
    } finally {
        dispatch({
            type: actions.LOADER_MATRIX_NINE_BOXES,
            payload: false,
        });
    }
}
